module.exports = __webpack_public_path__ + "static/media/abyss.39d359bd.jpg";